/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
import { effect } from '@angular/core';
import { getState, signalStoreFeature, withHooks } from '@ngrx/signals';
import { environment } from 'src/environments/environment';

export function withLogger(name?: string) {
	return signalStoreFeature(
		withHooks({
			onInit(store) {
				effect(() => {
					if (!environment.production) {
						const state = getState(store);
						console.log(`%c⧭ transport ${name} state changed: `, 'color: #00ff00', state);
					}
				});
			},
		}),
	);
}
